/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  component: {
    color: {
      component: {
        border: {
          divider: {
            "level 1": "#ffffff",
            "level 2": "#ededed",
            "level 3": "#dadada",
          },
          input: {
            "level 1": "#dadada",
            "level 2": "#b2b2b2",
            focus: "#00396c",
          },
          table: {
            "expanded row": "#caded8",
            "row divider": "#dadada",
          },
        },
      },
      background: {
        box: {
          informative: "#daf0fc",
          warning: "#ffe6ab",
          error: "#f2d0cf",
          neutral: "#f6f6f6",
          success: "#caded8",
        },
        header: {
          "level 1": "#004c90",
          "level 2": "#00396c",
        },
        "page content": {
          "level 1": "#ffffff",
          "level 2": "#f6f6f6",
        },
        table: {
          header: "#006774",
          "header hover": "#02515e",
          row: "#ffffff",
          "row alternate": "#f6f6f6",
          "row active": "#caded8",
          "row hover": "#e4eeeb",
        },
      },
    },
  },
};
